export default `
  mutation addPaymentMethod($paymentMethodId: String, $newCustomerInfo: StripeNewCustomerInfoInput) {
    addPaymentMethod(paymentMethodId: $paymentMethodId, newCustomerInfo: $newCustomerInfo) {
      success
      message
    }
  }
`
